module.exports = __webpack_public_path__ + "static/media/eng_d_2379.77973aad.mp4";